<script>
    import { select } from 'd3-selection';
    import { getContext } from 'svelte';
    import Day from './Day.svelte';

    // --- Properties
    export let dataKey;
    export let transactionKey;
    export let nr;

    const days = Array.from({length: 7}, 
        (v, i) => 6 + i + (nr-1) * 7);  
    const weekdays = [
        'Monday', 'Tuesday', 'Wednesday', 
        'Thursday', 'Friday', 'Saturday', 
        'Sunday'
    ];
    
    // --- Time scale
    let timeAxisG;
    const { timeAxis, timeScale, w } = getContext(transactionKey);
    $: updateAxis($w);

    function updateAxis(w) {
        timeScale.range([10, w/2-5]);
        if (timeAxisG) {
            select(timeAxisG)
                .call(timeAxis)
                .call(g => g.select('.domain').remove());
        }
    }

</script>

<div id='week' class='col'>
    {#each days as dayNr, i}
        <Day weekday={weekdays[i]} {dayNr} {dataKey} {transactionKey}/>
    {/each}
    <svg width={$w/2-5} height={15}>
        <g class='timeaxis' bind:this={timeAxisG} transform='translate(0, -1)'></g>
    </svg>
</div>

<style>    
#week {
    width: calc(50%);
    height: calc(100%);   
    flex-grow: 0;
    flex-shrink: 0;
}
</style>